import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import DashboardCard from "../common/DashboardCard";
import { formatNumber } from "../../../utils/utilityfunc";
import { useGetFetch } from "../../../data/Queries";
import {
  gymDashBoardReportGet,
  gymDashBoardReportGetKey,
  settlementCTOStatsGet,
  settlementCTOStatsGetKey,
} from "../../../data/ApiEndpoints";
import ModalHeadAndClose from "../../../components/payouts-wtf/common/ModalHeadAndClose";
import FixedLayoutTable from "../../../components/common-components/FixedLayoutTable";
import DailyTarget from "../common/DailyTarget";
import {
  calcDailyTarget2,
  remainingTarget,
} from "../../../components/common-data/Calculations";
import SalesCard from "../common/SalesCard";
import { fetchAgentTargetStatsData } from "../../../redux/prospect-reducers/prospectSlice";
import { fetchPaymentLinkHomeStatData } from "../../../redux/plans-reducers/plansSlice";
import { fetchAllCashPaymentLinksData } from "../../../redux/reducers/apiSlice";
import {
  convertThenFormat,
  currentDateOfTheMonth,
  currentMonthNumber,
  currentYear,
  formattedAmount,
} from "../../../components/common-data/Converts";
import AgentwiseDailyTagrget from "../agents/AgentwiseDailyTagrget";
import useInterval from "../../../components/common-components/custom-hooks/useInterval";
import DotLoaders from "../../../components/common-components/loaders/DotLoaders";
import CommonStatCard from "../../../components/pt/pt-flow-new/CommonStatCard";
import HomePMLinkDetails from "../detail-modals/HomePMLinkDetails";
import {
  GreenCheckIcon,
  HoldingMoneyIcon,
  HourglassIcon,
} from "../../../images/icons/icons";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Cards2 = ({ user, filters, allFilters, registerApiCall, isBetaMode }) => {
  const dispatch = useDispatch();
  const { agentTargetStats, agentTargetStatsLoading, agentTargetStatsError } =
    useSelector((state) => state.prospects);
  const {
    paymentLinkHomeStat,
    paymentLinkHomeStatLoading,
    paymentLinkHomeStatError,
  } = useSelector((state) => state.plans);
  const { allCashPaymentData, loading: cashPaymentLoading } = useSelector(
    (state) => state.api
  );

  const isAdmin = user?.account_type === "admin";
  const isClusterManager = user?.account_type === "cluster_manager";

  const [agentsTargetStats, setAgentsTargetStats] = useState(null);
  const [paymentLinkHomeStatData, setPaymentLinkHomeStatData] = useState(null);
  const [cashPaymentStats, setCashPaymentStats] = useState(null);
  const iniModVal = {
    targetModal: false,
    clickedCard: "",
    clickedCardValue: "",
  };
  const [modValues, setModValues] = useState(iniModVal);

  const {
    data: settlementCTOStatsData,
    isLoading: isLoadingSettleMentStats,
    isFetching: isFetchingSettlementStats,
    refetch: refetchSettlementStats,
  } = useGetFetch({
    token: user?.token,
    url: settlementCTOStatsGet,
    key: settlementCTOStatsGetKey,
    filters: filters,
  });

  const {
    data: gymDashboardData,
    isLoading: isLoadingGymDashboard,
    isFetching: isFetchingGymDashboard,
    refetch: refetchGymDashboard,
  } = useGetFetch({
    token: user?.token,
    url: gymDashBoardReportGet,
    key: gymDashBoardReportGetKey,
    filters: filters,
  });

  function isFetchingData() {
    try {
      if (isLoadingSettleMentStats || isFetchingSettlementStats) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  function isFetchingData1() {
    try {
      if (isLoadingGymDashboard || isFetchingGymDashboard) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  const onCloseModal = () => {
    setModValues(iniModVal);
  };

  const onClickCard = (cardName, cardFilter) => {
    setModValues({
      targetModal: true,
      clickedCard: cardName,
      clickedCardValue: cardFilter,
    });
  };

  const onClickCard1 = (cardName) => {
    setModValues({
      targetModal: true,
      clickedCard:
        cardName === "total_sales"
          ? "sales_month"
          : cardName === "todays_sale" || cardName === "sales_today"
          ? "today"
          : cardName,
    });
  };

  function getAgentTargetStats(filters) {
    const sendableFilter = {
      ...filters,
      month: currentMonthNumber,
      year: currentYear,
      staff_id:
        !isAdmin && !isClusterManager ? user?.uid || user?.user_id || "" : "",
    };

    if (!isAdmin && !isClusterManager && sendableFilter.staff_id) {
      dispatch(
        fetchAgentTargetStatsData({
          filters: sendableFilter,
          token: user?.token,
        })
      );
    } else if (isAdmin || isClusterManager) {
      dispatch(
        fetchAgentTargetStatsData({
          filters: sendableFilter,
          token: user?.token,
        })
      );
    }
  }

  function getPaymentLinkHomeStat(filters) {
    const sendableFilters = {
      ...filters,
      start_date: currentDateOfTheMonth,
      end_date: currentDateOfTheMonth,
    };

    dispatch(
      fetchPaymentLinkHomeStatData({
        filters: sendableFilters,
        token: user?.token,
      })
    );
  }

  function getCashPaymentLinks(filters) {
    const sendableFilters = {
      ...filters,
      page: 1,
      start_date: currentDateOfTheMonth,
      end_date: currentDateOfTheMonth,
    };

    dispatch(
      fetchAllCashPaymentLinksData({
        filters: sendableFilters,
        token: user?.token,
      })
    );
  }

  const fetchAPIs = () => {
    try {
      refetchSettlementStats();
      refetchGymDashboard();
      getAgentTargetStats(filters);
      getPaymentLinkHomeStat(filters);
      getCashPaymentLinks(filters);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const calculateDailyTargetFromMonthly = (monthlyTarget) => {
    if (!monthlyTarget) return 0;
    const currentDate = new Date();
    const daysInMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate();
    return monthlyTarget / daysInMonth;
  };

  const calculateDailyTargetTrend = (monthlyTarget, monthlyAchieved) => {
    if (!monthlyTarget || !monthlyAchieved) return "straight";

    const dailyTarget = calculateDailyTargetFromMonthly(monthlyTarget);
    const currentDate = new Date();
    const currentDay = currentDate.getDate();
    const expectedAchievement = dailyTarget * currentDay;

    if (monthlyAchieved > expectedAchievement) return "up";
    if (monthlyAchieved < expectedAchievement) return "down";
    return "straight";
  };

  const calculateTargetAchievementTrend = (monthlyTarget, monthlyAchieved) => {
    if (!monthlyTarget || !monthlyAchieved) return "straight";

    const currentDate = new Date();
    const currentDay = currentDate.getDate();
    const daysInMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate();

    const expectedAchievement = (monthlyTarget / daysInMonth) * currentDay;

    if (monthlyAchieved >= expectedAchievement) return "up";

    return "down";
  };

  const calculateRemainingTargetTrend = (monthlyTarget, monthlyAchieved) => {
    if (!monthlyTarget || !monthlyAchieved) return "straight";

    const remaining = monthlyTarget - monthlyAchieved;
    const currentDate = new Date();
    const currentDay = currentDate.getDate();
    const daysInMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate();
    const expectedRemaining = monthlyTarget * (1 - currentDay / daysInMonth);

    if (remaining < expectedRemaining) return "up";
    if (remaining > expectedRemaining) return "down";
    return "straight";
  };

  const calculateSalesTodayTrend = (todaySale) => {
    if (!todaySale) return "straight";

    // const dailyTarget = calculateDailyTargetFromMonthly(monthlyTarget);
    const dailyTarget = calcDailyTarget2(
      settlementCTOStatsData?.stats?.target_value,
      settlementCTOStatsData?.stats?.target_value_acheived
    );

    if (todaySale >= dailyTarget) return "up";
    return "down";
  };

  const sortedData =
    settlementCTOStatsData?.data && settlementCTOStatsData?.data?.length > 1
      ? [...settlementCTOStatsData?.data].sort(
          (a, b) =>
            parseInt(b.target_acheived || 0) - parseInt(a.target_acheived || 0)
        )
      : [];

  useEffect(() => {
    if (registerApiCall) {
      registerApiCall(refetchSettlementStats);
      registerApiCall(refetchGymDashboard);
      registerApiCall(() => getAgentTargetStats(filters));
      registerApiCall(() => getPaymentLinkHomeStat(filters));
      registerApiCall(() => getCashPaymentLinks(filters));
    }
  }, [registerApiCall]);

  useEffect(() => {
    try {
      refetchSettlementStats();
    } catch (error) {
      console.log(error);
    }

    getAgentTargetStats(filters);
    getPaymentLinkHomeStat(filters);
    getCashPaymentLinks(filters);
  }, [filters]);

  useInterval(fetchAPIs, 300000);

  useEffect(() => {
    try {
      refetchGymDashboard();
    } catch (error) {
      console.log(error);
    }
  }, [filters.gym_id]);

  useEffect(() => {
    if (
      agentTargetStats?.status &&
      agentTargetStats?.data &&
      !agentTargetStatsLoading
      // && !agentTargetStatsError
    ) {
      setAgentsTargetStats(agentTargetStats?.data);
    } else {
      setAgentsTargetStats(null);
    }
  }, [agentTargetStats, agentTargetStatsLoading, agentTargetStatsError]);

  useEffect(() => {
    if (
      paymentLinkHomeStat?.status &&
      paymentLinkHomeStat?.data &&
      !paymentLinkHomeStatLoading
    ) {
      setPaymentLinkHomeStatData(paymentLinkHomeStat?.data);
    } else {
      setPaymentLinkHomeStatData(null);
    }
  }, [
    paymentLinkHomeStat,
    paymentLinkHomeStatLoading,
    paymentLinkHomeStatError,
  ]);

  useEffect(() => {
    if (allCashPaymentData?.status && !cashPaymentLoading) {
      const {
        totalVolume,
        totalCash,
        totalCashApproved,
        totalCashNotApproved,
        totalCashCompleted,
        totalCashPending,
        totalCashFailed,
      } = allCashPaymentData;

      setCashPaymentStats({
        totalVolume: totalVolume || 0,
        totalCash: totalCash || 0,
        totalCashApproved: totalCashApproved || 0,
        totalCashNotApproved: totalCashNotApproved || 0,
        totalCashCompleted: totalCashCompleted || 0,
        totalCashPending: totalCashPending || 0,
        totalCashFailed: totalCashFailed || 0,
      });
    } else {
      setCashPaymentStats(null);
    }
  }, [allCashPaymentData, cashPaymentLoading]);

  const getTargetAchievementChartData = () => {
    const targetValue = settlementCTOStatsData?.stats?.target_value || 0;
    const achievedValue =
      settlementCTOStatsData?.stats?.target_value_acheived || 0;
    const remainingValue = Math.max(0, targetValue - achievedValue);

    return {
      labels: ["Target Achievement"],
      datasets: [
        {
          label: "Achieved",
          data: [achievedValue],
          backgroundColor: "#28a745",
          borderColor: "#28a745",
          borderWidth: 1,
          borderRadius: 8,
        },
        {
          label: "Remaining",
          data: [remainingValue],
          backgroundColor: "#ffc107",
          borderColor: "#ffc107",
          borderWidth: 1,
          borderRadius: 8,
        },
      ],
    };
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          padding: window.innerWidth <= 768 ? 10 : 20,
          font: {
            size: window.innerWidth <= 768 ? 10 : 12,
            weight: "bold",
          },
          boxWidth: window.innerWidth <= 768 ? 8 : 12,
          boxHeight: window.innerWidth <= 768 ? 8 : 12,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ₹${formatNumber(
              context.parsed.y
            )}`;
          },
        },
        titleFont: {
          size: window.innerWidth <= 768 ? 11 : 13,
        },
        bodyFont: {
          size: window.innerWidth <= 768 ? 10 : 12,
        },
        padding: window.innerWidth <= 768 ? 8 : 12,
      },
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        beginAtZero: true,
        max: settlementCTOStatsData?.stats?.target_value || 0,
        ticks: {
          callback: function (value) {
            return "₹" + formatNumber(value);
          },
          stepSize: function (context) {
            const max = settlementCTOStatsData?.stats?.target_value || 0;
            return max / 2;
          },
          maxTicksLimit: 3,
          font: {
            size: window.innerWidth <= 768 ? 9 : 11,
          },
        },
        title: {
          display: window.innerWidth > 768,
          font: {
            size: window.innerWidth <= 768 ? 12 : 14,
            weight: "bold",
          },
          color: "#333",
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 1,
        borderRadius: window.innerWidth <= 768 ? 2 : 4,
        barThickness: window.innerWidth <= 768 ? 2 : 10,
        maxBarThickness: window.innerWidth <= 768 ? 4 : 15,
      },
    },
    maxHeight: 300,
    maxWidth: 330,
  };

  return (
    <>
      <Modal
        isOpen={modValues.targetModal}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={`${
              modValues.clickedCard === "active_members"
                ? ""
                : modValues.clickedCard === "FD_target"
                ? ""
                : modValues.clickedCard === "home-pm-link-details"
                ? `Payment Links Today | ${modValues.clickedCardValue?.replace(
                    /_/g,
                    " "
                  )}`
                : modValues.clickedCard?.replace(/_/g, " ")
            }`}
            onClose={onCloseModal}
          />

          {modValues.clickedCard === "target_achieved" ? (
            <FixedLayoutTable
              name="dashboard-card"
              tbCols={[
                "Gym",
                "Gym Target",
                "Target Achieved",
                "Pending Target",
              ]}
              tbColumns={sortedData}
            />
          ) : modValues.clickedCard === "daily_target" ||
            modValues.clickedCard === "remaining_target" ? (
            <DailyTarget
              user={user}
              gymFilterObj={allFilters.selectedGym}
              prevAllFilters={allFilters}
              isDashboardCards={true}
            />
          ) : modValues.clickedCard === "sales_month" ? (
            <SalesCard
              user={user}
              clickedCard={modValues.clickedCard}
              filters={filters}
              prevSelGym={allFilters.selectedGym}
              prevPrevAllFilters={allFilters}
            />
          ) : modValues.clickedCard === "FD_target" ? (
            <AgentwiseDailyTagrget
              userInfoData={user}
              prevAllFilters={allFilters}
            />
          ) : modValues.clickedCard === "active_members" ||
            modValues.clickedCard === "today" ? (
            <SalesCard
              user={user}
              clickedCard={modValues.clickedCard}
              filters={filters}
              prevSelGym={allFilters.selectedGym}
              prevPrevAllFilters={allFilters}
              cardName={modValues.cardName}
              isPreSale={modValues.isPreSale}
            />
          ) : modValues.clickedCard === "home-pm-link-details" ? (
            <HomePMLinkDetails
              userInfoData={user}
              prevPrevAllFilters={allFilters}
              prevFilters={filters}
              clickedCard={modValues.clickedCardValue}
            />
          ) : null}
        </div>
      </Modal>

      {isBetaMode ? (
        <>
          <div className="lead-v2-stat-card-row home-colored-stat mt30">
            <div className={`lead-v2-stat-card blue cursor-not-allowed`}>
              <div className="lead-v2-stat-card-content">
                <div className="lead-v2-stat-card-label">Monthly Target</div>
                <div className="lead-v2-stat-card-value">
                  {isFetchingData() ? (
                    <DotLoaders />
                  ) : settlementCTOStatsData?.stats?.target_value ? (
                    `₹${formattedAmount(
                      settlementCTOStatsData.stats.target_value
                    )}`
                  ) : (
                    `₹0`
                  )}
                </div>
              </div>
            </div>

            <div
              className={`lead-v2-stat-card orange cursor-pointer`}
              onClick={() => onClickCard1("total_sales")}
            >
              <div className="lead-v2-stat-card-content">
                <div className="lead-v2-stat-card-label">Total Sales</div>
                <div className="lead-v2-stat-card-value">
                  {isFetchingData1() ? (
                    <DotLoaders />
                  ) : gymDashboardData?.data?.totalSalesMonth ? (
                    `₹${formattedAmount(gymDashboardData.data.totalSalesMonth)}`
                  ) : (
                    `₹0`
                  )}
                </div>
              </div>
            </div>

            <div className={`lead-v2-stat-card green cursor-not-allowed`}>
              <div className="lead-v2-stat-card-content">
                <div className="lead-v2-stat-card-label">Net Revenue</div>
                <div className="lead-v2-stat-card-value">
                  {isFetchingData() ? (
                    <DotLoaders />
                  ) : settlementCTOStatsData?.stats?.net_income ? (
                    `₹${formattedAmount(
                      settlementCTOStatsData.stats.net_income || 0
                    )}`
                  ) : (
                    "₹0"
                  )}
                </div>
              </div>
            </div>

            <div
              className={`lead-v2-stat-card purple cursor-pointer`}
              onClick={() =>
                setModValues({
                  targetModal: true,
                  clickedCard: "active_members",
                  cardName: "active_members",
                  isPreSale: false,
                })
              }
            >
              <div className="lead-v2-stat-card-content">
                <div className="lead-v2-stat-card-label">Active members</div>
                <div className="lead-v2-stat-card-value">
                  {isFetchingData() ? (
                    <DotLoaders />
                  ) : gymDashboardData?.data?.activeMembers ? (
                    formattedAmount(gymDashboardData.data.activeMembers)
                  ) : (
                    0
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="home-sales-cards-container grid-3 mt30">
            <div className="home-sales-card-box span2">
              <p className="home-sales-card-box-title">Sales Performance</p>

              <div className="home-sales-card-box-divider">
                <div className="cards-container cards-grid-container grid-4">
                  <CommonStatCard
                    tagName="home"
                    cardLabel="Sales Today"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${formattedAmount(gymDashboardData?.data?.todaySale)}`
                      )
                    }
                    trend={calculateSalesTodayTrend(
                      gymDashboardData?.data?.todaySale,
                      settlementCTOStatsData?.stats?.target_value
                    )}
                    onClickCard={() => onClickCard1("todays_sale")}
                  />

                  <CommonStatCard
                    tagName="home"
                    cardLabel="Daily Target"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : settlementCTOStatsData?.stats?.target_value &&
                        settlementCTOStatsData?.stats?.target_value_acheived ? (
                        `₹${convertThenFormat(
                          calcDailyTarget2(
                            settlementCTOStatsData?.stats?.target_value,
                            settlementCTOStatsData?.stats?.target_value_acheived
                          ) || 0
                        )}`
                      ) : (
                        `₹0`
                      )
                    }
                    trend={calculateDailyTargetTrend(
                      settlementCTOStatsData?.stats?.target_value,
                      settlementCTOStatsData?.stats?.target_value_acheived
                    )}
                    onClickCard={() => onClickCard("daily_target")}
                  />

                  <CommonStatCard
                    tagName="home"
                    cardLabel="Target Achieved"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : settlementCTOStatsData?.stats
                          ?.target_value_acheived ? (
                        `₹${formattedAmount(
                          settlementCTOStatsData.stats.target_value_acheived
                        )}`
                      ) : (
                        `₹0`
                      )
                    }
                    trend={calculateTargetAchievementTrend(
                      settlementCTOStatsData?.stats?.target_value,
                      settlementCTOStatsData?.stats?.target_value_acheived
                    )}
                    onClickCard={() => onClickCard("target_achieved")}
                  />

                  <CommonStatCard
                    tagName="home"
                    cardLabel="Remaining Target"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : settlementCTOStatsData?.stats?.target_value &&
                        settlementCTOStatsData.stats.target_value_acheived ? (
                        `₹${convertThenFormat(
                          remainingTarget(
                            settlementCTOStatsData?.stats?.target_value || 0,
                            settlementCTOStatsData.stats
                              .target_value_acheived || 0
                          ) || 0
                        )}`
                      ) : (
                        "₹0"
                      )
                    }
                    trend={calculateRemainingTargetTrend(
                      settlementCTOStatsData?.stats?.target_value,
                      settlementCTOStatsData?.stats?.target_value_acheived
                    )}
                    onClickCard={() => onClickCard("remaining_target")}
                  />
                </div>

                <div className="grayLine"></div>

                <div className="cards-container cards-grid-container grid-3">
                  <CommonStatCard
                    tagName="home"
                    classname="span2"
                    cardLabel="FD Target (acheived/total)"
                    value={
                      agentTargetStatsLoading ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${convertThenFormat(
                          agentsTargetStats?.target_acheived || 0
                        )}/${convertThenFormat(
                          agentsTargetStats?.total_target || 0
                        )}`
                      )
                    }
                    onClickCard={() => onClickCard("FD_target")}
                  />

                  <CommonStatCard
                    tagName="home"
                    cardLabel="Total GST Collected"
                    value={
                      isFetchingData() ? (
                        <DotLoaders color="#000" />
                      ) : settlementCTOStatsData?.stats?.total_gst ? (
                        `₹${formattedAmount(
                          settlementCTOStatsData.stats.total_gst || 0
                        )}`
                      ) : (
                        "₹0"
                      )
                    }
                  />
                </div>
              </div>
            </div>

            <div className="home-sales-card-box">
              <p className="home-sales-card-box-title">
                Monthly Target Achievement
              </p>

              <div className="home-sales-card-box-graph">
                {isFetchingData() ? (
                  <DotLoaders color="#000" />
                ) : (
                  <>
                    <div className="home-card-chart-container">
                      <Bar
                        data={getTargetAchievementChartData()}
                        options={chartOptions}
                      />
                    </div>

                    <div className="home-card-chart-legends">
                      <div className="home-card-legends-row">
                        <span className="home-card-legend-item">
                          <span className="home-card-legend-dot home-card-legend-achieved">
                            ●
                          </span>
                          Achieved: ₹
                          {formattedAmount(
                            settlementCTOStatsData?.stats
                              ?.target_value_acheived || 0
                          )}
                        </span>
                        <span className="home-card-legend-item">
                          <span className="home-card-legend-dot home-card-legend-remaining">
                            ●
                          </span>
                          Remaining: ₹
                          {formattedAmount(
                            Math.max(
                              0,
                              (settlementCTOStatsData?.stats?.target_value ||
                                0) -
                                (settlementCTOStatsData?.stats
                                  ?.target_value_acheived || 0)
                            )
                          )}
                        </span>
                      </div>
                      {/* <div className="home-card-total-target">
                        <span className="home-card-total-text">
                          Total Target: ₹
                          {formattedAmount(
                            settlementCTOStatsData?.stats?.target_value || 0
                          )}
                        </span>
                      </div> */}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="home-sales-card-box span3">
              <p className="home-sales-card-box-title">Payment Links Today</p>

              <div className="home-sales-card-box-divider">
                <div className="cards-container cards-grid-container grid-3">
                  <CommonStatCard
                    tagName="home"
                    classname="pm-link-home-stat-card"
                    cardLabel="Total Online Links Sent"
                    value={
                      paymentLinkHomeStatLoading ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${convertThenFormat(
                          paymentLinkHomeStatData?.total_online || 0
                        )}(${
                          paymentLinkHomeStatData?.total_payment_link_sent || 0
                        })`
                      )
                    }
                    valueIcon={<HoldingMoneyIcon color="#4a6f6f" />}
                    onClickCard={() =>
                      onClickCard("home-pm-link-details", "total_online")
                    }
                  />

                  <CommonStatCard
                    tagName="home"
                    classname="pm-link-home-stat-card"
                    cardLabel="Online Completed"
                    value={
                      paymentLinkHomeStatLoading ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${formattedAmount(
                          paymentLinkHomeStatData?.total_online_completed || 0
                        )}
                        (${formattedAmount(
                          paymentLinkHomeStatData?.total_completed_online_payment ||
                            0
                        )})
                        `
                      )
                    }
                    valueIcon={<GreenCheckIcon color="#4a6f6f" />}
                    onClickCard={() =>
                      onClickCard("home-pm-link-details", "online_completed")
                    }
                  />

                  <CommonStatCard
                    tagName="home"
                    classname="pm-link-home-stat-card"
                    cardLabel="Online Pending"
                    value={
                      paymentLinkHomeStatLoading ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${convertThenFormat(
                          paymentLinkHomeStatData?.total_online_pending || 0
                        )}(${formattedAmount(
                          paymentLinkHomeStatData?.total_pending_online_payment ||
                            0
                        )})`
                      )
                    }
                    valueIcon={<HourglassIcon color="#4a6f6f" />}
                    onClickCard={() =>
                      onClickCard("home-pm-link-details", "online_pending")
                    }
                  />
                </div>

                <div className="grayLine"></div>

                <div className="cards-container cards-grid-container grid-3">
                  <CommonStatCard
                    tagName="home"
                    classname="pm-link-home-stat-card"
                    cardLabel="Total Cash Link Sent"
                    value={
                      cashPaymentLoading ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${convertThenFormat(
                          cashPaymentStats?.totalCash || 0
                        )}`
                      )
                    }
                    valueIcon={<HoldingMoneyIcon color="#4a6f6f" />}
                    onClickCard={() =>
                      onClickCard("home-pm-link-details", "total_cash")
                    }
                  />

                  <CommonStatCard
                    tagName="home"
                    classname="pm-link-home-stat-card"
                    cardLabel="Cash Approved"
                    value={
                      cashPaymentLoading ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${convertThenFormat(
                          cashPaymentStats?.totalCashApproved || 0
                        )}`
                      )
                    }
                    valueIcon={<GreenCheckIcon color="#4a6f6f" />}
                    onClickCard={() =>
                      onClickCard("home-pm-link-details", "cash_approved")
                    }
                  />

                  <CommonStatCard
                    tagName="home"
                    classname="pm-link-home-stat-card"
                    cardLabel="Cash Approval Pending"
                    value={
                      cashPaymentLoading ? (
                        <DotLoaders color="#000" />
                      ) : (
                        `₹${convertThenFormat(
                          cashPaymentStats?.totalCashPending || 0
                        )}`
                      )
                    }
                    valueIcon={<HourglassIcon color="#4a6f6f" />}
                    onClickCard={() =>
                      onClickCard("home-pm-link-details", "cash_pending")
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="cards-container cards-grid-container grid-4 mob-grid-1">
          {isFetchingData() ? (
            <ReactVortoxSpinner />
          ) : (
            <>
              <DashboardCard
                tagName={"target"}
                cardLabel={"Monthly Target"}
                value={
                  settlementCTOStatsData?.stats?.target_value
                    ? `₹${formattedAmount(
                        settlementCTOStatsData.stats.target_value
                      )}`
                    : `₹0`
                }
                onClickCard={onClickCard}
              />

              <DashboardCard
                tagName={"target"}
                cardLabel={"Daily Target"}
                value={
                  settlementCTOStatsData?.stats?.target_value &&
                  settlementCTOStatsData?.stats?.target_value_acheived
                    ? `₹${formattedAmount(
                        calcDailyTarget2(
                          settlementCTOStatsData?.stats?.target_value,
                          settlementCTOStatsData?.stats?.target_value_acheived
                        ) || 0
                      )}`
                    : `₹0`
                }
                onClickCard={onClickCard}
              />
              <DashboardCard
                tagName={"target"}
                cardLabel={"Target Achieved"}
                value={
                  settlementCTOStatsData?.stats?.target_value_acheived
                    ? `₹${formattedAmount(
                        settlementCTOStatsData.stats.target_value_acheived
                      )}`
                    : `₹0`
                }
                onClickCard={onClickCard}
              />
              <DashboardCard
                tagName={"target"}
                cardLabel={"Remaining Target"}
                value={
                  settlementCTOStatsData?.stats?.target_value &&
                  settlementCTOStatsData.stats.target_value_acheived
                    ? `₹${convertThenFormat(
                        remainingTarget(
                          settlementCTOStatsData?.stats?.target_value || 0,
                          settlementCTOStatsData.stats.target_value_acheived ||
                            0
                        ) || 0
                      )}`
                    : "₹0"
                }
                onClickCard={onClickCard}
              />
            </>
          )}

          {isFetchingData1() ? (
            <ReactVortoxSpinner />
          ) : (
            <DashboardCard
              tagName={"sales"}
              cardLabel={"Total Sales"}
              value={
                gymDashboardData?.data?.totalSalesMonth
                  ? `₹${formattedAmount(gymDashboardData.data.totalSalesMonth)}`
                  : `₹0`
              }
              onClickCard={onClickCard1}
            />
          )}

          {isFetchingData() ? (
            <ReactVortoxSpinner />
          ) : (
            <>
              <DashboardCard
                tagName={"target"}
                cardLabel={"Net Revenue"}
                value={
                  settlementCTOStatsData?.stats?.net_income
                    ? `₹${formattedAmount(
                        settlementCTOStatsData.stats.net_income || 0
                      )}`
                    : "₹0"
                }
              />

              <DashboardCard
                tagName={"target"}
                cardLabel={"Total GST Collected"}
                value={
                  settlementCTOStatsData?.stats?.total_gst
                    ? `₹${formattedAmount(
                        settlementCTOStatsData.stats.total_gst || 0
                      )}`
                    : "₹0"
                }
              />
            </>
          )}

          {agentsTargetStats && (
            <DashboardCard
              tagName={"FD_target"}
              cardLabel={"FD Target (acheived/total)"}
              value={`₹${convertThenFormat(
                agentsTargetStats?.target_acheived || 0
              )}/${convertThenFormat(agentsTargetStats?.total_target || 0)}`}
              onClickCard={onClickCard}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Cards2;
